import MembershipLayout from '../../views/setting/membership/Index'
import MembershipList from '../../views/setting/membership/List'
import MembershipCreate from '../../views/setting/membership/Create'
import MembershipEdit from '../../views/setting/membership/Edit'
import MembershipShow from '../../views/setting/membership/Show'
import Permissions from '@/permissions'

export const membershipRouters = {
  path: 'membership',
  component: MembershipLayout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.setting.membership.manage],
    groups: 'membership'
  },
  children: [
    {
      path: '',
      name: 'Membership',
      component: MembershipList,
      meta: {
        permissions: [Permissions.backend.setting.membership.list],
        groups: 'membership',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Membership',
            name_km: 'សមាជិក'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'create',
      name: 'MembershipCreate',
      component: MembershipCreate,
      meta: {
        permissions: [Permissions.backend.setting.membership.list],
        groups: 'membership',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Membership',
            name_km: 'សមាជិក'
          },
          {
            name_en: 'Create',
            name_km: 'បង្កើត'
          }
        ]
      }
    },
    {
      path: 'edit/:uuid',
      name: 'MembershipEdit',
      component: MembershipEdit,
      meta: {
        permissions: [Permissions.backend.setting.membership.list],
        groups: 'membership',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Membership',
            name_km: 'សមាជិក'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'show/:uuid',
      name: 'MembershipShow',
      component: MembershipShow,
      meta: {
        permissions: [Permissions.backend.setting.membership.list],
        groups: 'membership',
        breadcrumb: [
          {
            name_en: 'Setting',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Membership',
            name_km: 'សមាជិក'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
